var map = {
	"./blue.svg": "0HLI",
	"./dark.svg": "IHGG",
	"./green.svg": "mz/3",
	"./greyWithBlack.svg": "aPKn",
	"./greyWithWhite.svg": "9UnF",
	"./lightBlue.svg": "GkK1",
	"./orange.svg": "nL2d",
	"./white.svg": "nF1b",
	"./yellow.svg": "NRko"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tN6F";